import React from "react";
import { NodeViewWrapper } from "@tiptap/react";
import { Card } from "@/components/ui/card";
import { Alert } from "@/components/ui/alert";

/**
 * OEmbed React NodeView for Tiptap
 * - Renders the oEmbed HTML or fallback
 */
export default function OEmbedComponent({ node }: any) {
  const { url, data } = node.attrs;

  return (
    <NodeViewWrapper>
      {!data ? (
        <Card className="my-4 p-4 bg-muted">
          <Alert variant="destructive">
            Failed to load embed for: {url}
          </Alert>
        </Card>
      ) : data.html ? (
        <Card className="my-4 p-4 bg-muted">
          <div
            className="oembed-html"
            dangerouslySetInnerHTML={{ __html: data.html }}
          />
        </Card>
      ) : (
        <Card className="my-4 p-4 bg-muted flex flex-col items-center">
          {data.thumbnail_url && (
            <img
              src={data.thumbnail_url}
              alt={data.title || url}
              className="mb-2 max-w-xs rounded"
            />
          )}
          <div className="text-sm text-muted-foreground">{data.title || url}</div>
        </Card>
      )}
    </NodeViewWrapper>
  );
}
